var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9878 13.0129L16.9848 8.00984C15.8161 6.84114 13.9211 6.84114 12.7524 8.00984L2.87653 17.8857C1.70782 19.0544 1.70782 20.9494 2.87653 22.1181L12.7524 31.9945C13.9211 33.1632 15.8161 33.1632 16.9848 31.9945L27.27 21.7092C27.9 21.0792 27.4538 20.0021 26.563 20.0021L17.4365 20.0017C16.5457 20.0017 16.0995 18.9246 16.7295 18.2946C18.5007 16.5234 20.2718 14.7523 22.0431 12.981C23.7002 11.3239 25.3577 9.66638 27.0147 8.00934C28.1834 6.84064 30.0784 6.84064 31.2471 8.00934L41.1235 17.8857C42.2922 19.0544 42.2922 20.9494 41.1235 22.1181L31.2471 31.9945C30.0784 33.1632 28.1834 33.1632 27.0147 31.9945C25.3647 30.3444 23.7146 28.6944 22.0646 27.0443",
    stroke: "url(#paint0_linear_2152_53687)",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9878 13.0129L16.9848 8.00984C15.8161 6.84114 13.9211 6.84114 12.7524 8.00984L2.87653 17.8857C1.70782 19.0544 1.70782 20.9494 2.87653 22.1181L12.7524 31.9945C13.9211 33.1632 15.8161 33.1632 16.9848 31.9945L27.27 21.7092C27.9 21.0792 27.4538 20.0021 26.563 20.0021L17.4365 20.0017C16.5457 20.0017 16.0995 18.9246 16.7295 18.2946C18.5007 16.5234 20.2718 14.7523 22.0431 12.981C23.7002 11.3239 25.3577 9.66638 27.0147 8.00934C28.1834 6.84064 30.0784 6.84064 31.2471 8.00934L41.1235 17.8857C42.2922 19.0544 42.2922 20.9494 41.1235 22.1181L31.2471 31.9945C30.0784 33.1632 28.1834 33.1632 27.0147 31.9945C25.3647 30.3444 23.7146 28.6944 22.0646 27.0443",
    stroke: "#A100FF",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2152_53687",
    x1: 22.108,
    y1: 7.13281,
    x2: 22,
    y2: 32.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002991"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLogoIcon);
export default __webpack_public_path__ + "static/media/crm-logo-icon.f3c8f1768c60c26e4afb9dbf6d2419ec.svg";
export { ForwardRef as ReactComponent };